import { useTranslation } from "react-i18next";
import { Space, Image, Typography, List, Collapse, Tag, Row, Col, Button } from "antd"
import { useNavigate } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";

const { Text, Paragraph } = Typography;
const { Panel } = Collapse;

export const AwardsMobile = ({ awards }) => {
  const { t } = useTranslation("common");
  const navigate = useNavigate()

  return (
    <Row style={{ width: '100%', margin: "0px auto", padding: 10 }}>
      <Col span={24}>
        <List
          style={{ width: '100%' }}
          itemLayout="horizontal"
          dataSource={awards?.data}
          renderItem={award => (
            <Collapse style={{ border: '1px solid black', marginBottom: "16px" }} size="small" accordion >
              <Panel
                key={award.id}
                header={(
                  <Row style={{ width: '100%' }} >
                    <Col span={6} style={{ height: '100%' }}>
                      <Image
                        onClick={() => {
                          navigate(`/awards/${award.id}/edit`);
                          window.scroll(0, 0);
                        }}
                        width={50}
                        height={50}
                        src={award.imageUrl}
                        alt={award.imageUrl}
                        preview={false}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                        wrapperStyle={{ flexShrink: 0 }}
                      />
                    </Col>
                    <Col span={18} style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                      <Paragraph strong style={{ margin: 0 }} ellipsis={{ rows: 1, tooltip: true }}>
                        {award.name}
                      </Paragraph>
                      <Space wrap>
                        <Text style={{ color: '#1187CF' }} strong>
                          {t("awardTable.amount")}:
                        </Text>
                        {
                          award.amount.map(amount =>
                            <Space key={amount} style={{ justifyContent: 'space-around' }}>
                              <Tag color="blue" style={{ margin: 0 }}>{amount}</Tag>
                            </Space>)
                        }
                      </Space>
                    </Col>
                  </Row>
                )}
              >
                <Space direction="vertical" style={{ height: '100%' }}>
                  <Text>{award.description}</Text>
                  {award.available ? (
                    <Tag color="success">{t("awardTable.available")}</Tag>
                  ) : (
                    <Tag color="error">{t("awardTable.unavailable")}</Tag>
                  )}
                </Space>
              </Panel>
            </Collapse>
          )}
        />
      </Col>
      <Col span={24}>
        <Button
          type="primary"
          style={{ width: '100%' }}
          icon={<PlusOutlined />}
          onClick={() => {
            navigate(`/awards/create`);
            window.scroll(0, 0);
          }}
        >
          {t("awardTable.add")}
        </Button>
      </Col>
    </Row >
  )
}